import * as React from 'react';
import { createComponent } from '@lit/react';
import { NavWC } from './nav.wc';
import {
  GenerateComponentTypeWithChildren,
  GeneratePropsWithRef,
} from '../component-types-generics';

export type NavProps = GenerateComponentTypeWithChildren<NavWC>;

export type NavPropsWithRef = GeneratePropsWithRef<NavProps>;

export const Nav = createComponent({
  tagName: NavWC.tagname,
  elementClass: NavWC,
  react: React,
}) as NavPropsWithRef;
